import { Repository } from '../types/repository';

export const mockRepositories: Repository[] = [
  {
    id: 'repo-1',
    name: 'basic-nginx-demo',
    type: 'Git repository',
    url: 'https://github.com/flightctl/flightctl-demos',
    syncStatus: 'Accessible',
    lastTransition: '17 hours ago',
  },
  {
    id: 'repo-2',
    name: 'http-nginx-demo',
    type: 'HTTP service',
    url: 'https://nowhere.com/flightctl/flightctl-demos',
    syncStatus: 'No access',
    lastTransition: '17 hours ago',
  },
  {
    id: 'repo-3',
    name: 'oci-repo',
    type: 'OCI registry',
    url: 'https://quay.io',
    syncStatus: 'Accessible',
    lastTransition: '2 hours ago',
    credential: 'quay-io-credentials',
  },
  {
    id: 'repo-4',
    name: 'my-private-registry',
    type: 'OCI registry',
    url: 'https://registry.redhat.io',
    syncStatus: 'Accessible',
    lastTransition: '1 day ago',
    credential: 'redhat-registry-credentials',
  },
  {
    id: 'repo-5',
    name: 'rhel9/rhel-bootc:9.4',
    type: 'OCI registry',
    url: 'https://registry.redhat.io',
    syncStatus: 'Accessible',
    lastTransition: '1 day ago',
    credential: 'redhat-registry-credentials',
  },
  {
    id: 'repo-6',
    name: 'RHEL 9.4 - x86_64',
    type: 'OCI registry',
    url: 'https://registry.redhat.io',
    syncStatus: 'Accessible',
    lastTransition: '1 day ago',
    credential: 'redhat-registry-credentials',
  },
];

export const getRepositoryById = (id: string): Repository | undefined => {
  return mockRepositories.find(repo => repo.id === id);
};

export const addRepository = (repo: Omit<Repository, 'id'>): Repository => {
  const newRepo: Repository = {
    ...repo,
    id: `repo-${Date.now()}`
  };
  mockRepositories.push(newRepo);
  return newRepo;
};


